/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import LearnSubsectionAdminModalView from '../../Components/LearnSubsectionAdmin/Modal';
import { postLearnArticle } from '../../Util/ApiService';
import { displayToast } from '../../Util/Toast';

const LearnSubsectionAdminModal = ({
    addLearnSubsectionUri,
    updateLearnSubsectionUri,
    preFetchedSubsection,
    subsectionLanguages,
    type,
    sections,
    languages,
    sites
}) => {
    const [posting, setPosting] = useState(false);

    const postSubsection = async (
        image,
        learnSectionCode,
        languageCode,
        name,
        content,
        selectedSites
    ) => {
        setPosting(true);
        const formData = new FormData();

        if (typeof image === 'string' && preFetchedSubsection) {
            formData.append('imageUpdated', false);
        } else {
            if (image instanceof File) formData.append('image', image, image.name);
            formData.append('imageUpdated', true);
        }

        if (learnSectionCode) formData.append('learnSectionCode', learnSectionCode);
        if (languageCode) formData.append('languageCode', languageCode);
        if (name) formData.append('name', name);
        if (content !== undefined && content !== null) formData.append('content', content);
        if (sites) formData.append('sitesCodes', JSON.stringify(selectedSites || []));

        try {
            if (type === 'add') {
                await postLearnArticle(addLearnSubsectionUri, formData);
                setPosting(false);
                displayToast('Subcategory created', 'success');
                return location.reload();
            }
            await postLearnArticle(updateLearnSubsectionUri, formData);
            setPosting(false);
            displayToast('Subcategory updated', 'success');
            return location.reload();
        } catch (e) {
            setPosting(false);
            displayToast('Error submitting subcategory', 'error');
        }
    };

    return (
        <LearnSubsectionAdminModalView
            type={type}
            postSubsection={postSubsection}
            posting={posting}
            preFetchedSubsection={preFetchedSubsection}
            subsectionLanguages={subsectionLanguages}
            sections={sections}
            languages={languages}
            sites={sites}
        />
    );
};

export default LearnSubsectionAdminModal;

LearnSubsectionAdminModal.propTypes = {
    addLearnSubsectionUri: PropTypes.string,
    updateLearnSubsectionUri: PropTypes.string,
    preFetchedSubsection: PropTypes.string,
    subsectionLanguages: PropTypes.string,
    type: PropTypes.oneOf(['add', 'edit']),
    sections: PropTypes.string,
    languages: PropTypes.string,
    sites: PropTypes.string,
};
